<template>
	<div class="skyInput">
		<el-form-item :error="errorMessage">
			<el-input v-model="value" size="mini" @input="input" @change="change"></el-input>
			<template slot="errr">
				<div>{{ errorMessage }}</div>
			</template>
		</el-form-item>
	</div>
</template>
<script>
export default {
	props: ['scope', 'tableData'],
	data() {
		return {
			value: this.scope.row[this.tableData.bind] || 0,
			errorMessage: '',
		};
	},
	methods: {
		input() {
			let { scope, tableData } = this;
			this.errorMessage = tableData.change && tableData.change(this.value, scope.row);
		},
		change(val) {
			if (!val) {
				this.value = 0;
				this.input();
			}
		},
	},
	watch: {
		'scope.row': {
			handler(val) {
				this.value = val[this.tableData.bind];
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>

<style scoped lang="scss">
.skyInput {
  ::v-deep  .el-form-item {
    margin-top: 17px;
  }
}
</style>
